export default __webpack_public_path__ + "static/media/pec7.16a92648.jpg";